import { render, staticRenderFns } from "./teacherMatingDetail.vue?vue&type=template&id=df23bd9c&scoped=true&"
import script from "./teacherMatingDetail.vue?vue&type=script&lang=js&"
export * from "./teacherMatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./teacherMatingDetail.vue?vue&type=style&index=0&id=df23bd9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df23bd9c",
  null
  
)

export default component.exports